import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// --- Components ---
import Layout from '../../Utils/Navbar/navbar-layout-component.js';
import Footer from '../../Utils/Footer/footer-component';
import ServicesSection from './ServicesSection.js';
import ServicesMiddleSection from './ServicesMiddleSection.js';

// --- Utils & Sections ---
import FaqSection from '../../Utils/Sections/section-faq-component.js';
import HeroSection from '../../Utils/Sections/section-hero-component.js';

// --- Data ---
import { getServicesData } from '../../Public/services-data';
import { getServicesPageData } from '../../Public/services-page-data';
import ContentSection from '../../Utils/Content/content-section-component.js';
import QuickCallSection from '../../Utils/Sections/section-quick-call-component.js';

function ServicesScreen() {
    // 1. Redux & Localization
    const systemData = useSelector((s) => s.systemData || {});
    const { language } = systemData;

    // Fetch Page Content (Hero, Process, FAQ) from PLURAL file
    const pageContent = getServicesPageData(language).servicesPage;

    // 2. State
    const [servicesData, setServicesData] = useState([]);

    // 3. Init
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const init = async () => {
            const services = await getServicesData();
            setServicesData(services);
        };
        init();
    }, []);

    // 4. Construct Hero Content Object
    const heroContent = {
        heroTitle: pageContent?.hero?.title,
        heroTagline: pageContent?.hero?.tagline,
        heroDescription: pageContent?.hero?.description,
        heroSubDescription: pageContent?.hero?.subDescription,
        heroMedia: pageContent?.hero?.heroMedia
    };

    // 5. Prepare FAQ Cards
    const faqCards = (pageContent?.faqList || []).map((item, index) => ({
        id: index,
        question: item.question,
        answer: item.answer
    }));

    return (
        <div className="flex w-full flex-col justify-center bg-white dark:bg-black">
            <Layout>

                {/* 1. Hero Section */}
                <div className="flex w-full">
                    <HeroSection heroContent={heroContent} />
                </div>

                {/* 2. Intro Content */}
                <ContentSection
                    title={pageContent?.introTitle}
                    subtitle={pageContent?.introSubtitle}
                    backgroundColor="bg-white dark:bg-black"
                    className="!py-20 lg:!py-32"
                >
                </ContentSection>

                {/* 3. Main Services List */}
                <ServicesSection
                    services={servicesData}
                    isHeadline={false}
                    limit={null}
                    showMore={false}
                />

                <QuickCallSection/>

                {/* 4. Process & Stories (Passed explicitly) */}
                <div className='w-full border-t border-gray-100 dark:border-neutral-900'>
                    <ServicesMiddleSection
                        processData={pageContent?.process}
                        storiesData={pageContent?.stories}
                    />
                </div>

                {/* 5. FAQ */}
                <div className='flex w-full py-20 bg-gray-50 dark:bg-black border-t border-gray-100 dark:border-neutral-900'>
                    <div className="w-full flex flex-col items-center">
                        <div className="w-full max-w-7xl px-6">
                            <FaqSection faqCards={faqCards} />
                        </div>
                    </div>
                </div>

            </Layout>
            <Footer />
        </div>
    );
}

export default ServicesScreen;